//React component
import React from 'react'
import { useTranslation } from 'react-i18next'

//app component
import { AppLayout } from '../../layouts'
import { useAppSelector } from '../../stores'
import { useTheme } from '../../contexts/ThemeContext'
import { getTenantLogo } from '../../constants/Images'
import { getTenantName } from '../../utils/brandingStyles'


const MailVerification = () => {
    const users = useAppSelector((state) => state.auth.user);
    const { t } = useTranslation()
    const { theme } = useTheme()

    return (
        <AppLayout>
            <div className="mail-verification-page container p-5 text-center align-items-center justify-content-center">

                <div className="pb-5" style={{ marginTop: 100 }}>
                    <span><i className="fa-regular fa-envelope mail-verification-envelope my-5" style={{ fontSize: 100 }} aria-hidden /></span>
                    <div>
                        <>
                            <img className='' src={getTenantLogo(theme)} alt={getTenantName()} style={{ width: 140 }} />
                            <div className='mt-3'>
                                <span>{t('views.auth.hi')} <span className='text-theme'>{users?.fullname} </span></span>
                                <p className="mb-4 fs-6">{t('views.auth.amazingFeatures')}<br /> {t('views.auth.clicking')}</p>
                            </div>
                            <p className='mt-3'>{t('words.thank')}, <br />{t('views.auth.famlaTeam')}</p>
                        </>

                    </div>
                </div>

            </div>
        </AppLayout>
    )
}

export default MailVerification